import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { FinalProduct } from 'src/app/models/final_product.model';
import { ImageOutput } from 'src/app/models/image-output.model';
import { Layers } from 'src/app/models/layers.model';

export interface ImageState extends EntityState<ImageOutput> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'image' })
export class ImageStore extends EntityStore<ImageState, ImageOutput> {
  constructor() {
    super();
  }
}